import React from 'react';
import { Link } from 'react-router-dom/cjs/react-router-dom.min';
import Footer from '../components/Footer';
import Icon from '../components/Icon';
import resume from '../utils/Resume.pdf';

const Home = () => {
    return (
        <div className="flex flex-col justify-center items-center min-h-screen text-center pt-12">
            <div className="absolute top-0 right-0 mt-4 mr-4">
                <a
                    href={resume}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="flex items-center space-x-2 p-1 lg:py-1 lg:px-2 border-2 rounded-full lg:hover:bg-white lg:hover:bg-opacity-25 lg:transition lg:ease-in-out lg:duration-300"
                >
                    <svg
                        class="w-4 h-4"
                        fill="none"
                        stroke="currentColor"
                        viewBox="0 0 24 24"
                        xmlns="http://www.w3.org/2000/svg"
                    >
                        <path
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            strokeWidth="2"
                            d="M4 16v1a3 3 0 003 3h10a3 3 0 003-3v-1m-4-4l-4 4m0 0l-4-4m4 4V4"
                        ></path>
                    </svg>
                    <span className="text-xs font-medium hidden lg:block">
                        Resume
                    </span>
                </a>
            </div>
            <Icon />

            <div
                style={{
                    borderLeftWidth: 1,
                }}
                className="h-10 lg:h-12"
            />

            <div
                style={{
                    borderWidth: '1px 0px 1px 0px',
                }}
                className="lg:w-2/3 w-5/6"
            >
                <div className="intro_text">
                    <h1 className="pt-8 lg:pt-10 tracking-widest font-semibold text-xl lg:text-2xl">
                        HEY THERE!
                        <span role="img" aria-label="hi">
                            👋
                        </span>
                        <br />I AM SATEJ BIDVAI!
                    </h1>
                    <p className="pb-8 lg:pb-10 mt-4 lg:mt-4 tracking-widest mx-auto text-xs lg:text-sm leading-5">
                        <p>
                            A PASSIONATE DEVELOPER FROM INDIA,{' '}
                            <span className="block md:inline">
                                INTERESTED IN
                            </span>
                        </p>
                        FULL STACK WEB DEVELOPMENT.
                    </p>
                </div>
            </div>

            <div className="w-11/12 flex justify-center mx-auto">
                <div
                    style={{
                        borderWidth: 1,
                    }}
                    className="rounded-lg flex items-center justify-center lg:flex-row flex-col my-10 lg:mt-8 lg:mb-10 w-1/2 md:w-1/3 lg:w-5/12 lg:text-xs"
                >
                    <Link
                        to="/projects"
                        className="lg:hover:bg-white lg:hover:bg-opacity-25 lg:transition lg:ease-in-out lg:duration-300 w-full py-3 lg:focus:bg-transparent focus:bg-white focus:bg-opacity-25 lg:border-r-2"
                    >
                        PROJECTS
                    </Link>
                    <Link
                        to="/experience"
                        className="lg:hover:bg-white lg:hover:bg-opacity-25 lg:transition lg:ease-in-out lg:duration-300 w-full py-3 lg:focus:bg-transparent focus:bg-white focus:bg-opacity-25 lg:border-r-2"
                    >
                        EXPERIENCE
                    </Link>
                    <Link
                        to="/contact"
                        className="lg:hover:bg-white lg:hover:bg-opacity-25 lg:transition lg:ease-in-out lg:duration-300 w-full py-3 lg:focus:bg-transparent focus:bg-white focus:bg-opacity-25"
                    >
                        CONTACT ME
                    </Link>
                </div>
            </div>

            <Footer />
        </div>
    );
};

export default Home;
